export default __webpack_public_path__ + "static/media/ouro.1542ec0b.png";